import { render } from "./NosotrosView.vue?vue&type=template&id=1fe6c274&scoped=true"
import script from "./NosotrosView.vue?vue&type=script&lang=js"
export * from "./NosotrosView.vue?vue&type=script&lang=js"

import "./NosotrosView.vue?vue&type=style&index=0&id=1fe6c274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe6c274"]])

export default __exports__